import { render, staticRenderFns } from "./InventoryLabResultCreate.vue?vue&type=template&id=4d3253d5"
import script from "./InventoryLabResultCreate.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports